import { render, staticRenderFns } from "./GBRecordDetail.vue?vue&type=template&id=3169ff50&"
import script from "./GBRecordDetail.vue?vue&type=script&lang=js&"
export * from "./GBRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./GBRecordDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports